import { render, staticRenderFns } from "./c-content-chart-3d-pie@.vue?vue&type=template&id=c1fa6728&"
import script from "./c-content-chart-3d-pie@.vue?vue&type=script&lang=ts&"
export * from "./c-content-chart-3d-pie@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports